import { DataService } from '../dataService';

export const studentServices = {
    getStudentBook: () => {
        return DataService.get('/student/clone-book');
    },
    getStudentBookDetail: (id) => {
        return DataService.get(`/student/clone-book-slug/${id}`);
    },
    getStudentMainBookDetail: (id) => {
        return DataService.get(`/student/main-book-slug/${id}`);
    },

    /// read api for chapter header

    getStudentPaginationApi: (id) => {
        return DataService.get(`/student/main-chapter-sequence-slug/${id}`)
    },

    getChapterHeaderApi: (id) => {
        return DataService.get(`/student/clone-chapter/${id}`);
    },
    getHeaderOneApi: (id) => {
        return DataService.get(`/student/clone/header-1-clone/${id}`);
    },
    getHeaderTwoApi: (id) => {
        return DataService.get(`/student/clone/header-2-clone/${id}`);
    },
    getHeaderThreeApi: (id) => {
        return DataService.get(`/student/clone/header-3-clone/${id}`);
    },


    /// Main Book get Api

    getStudentMainPaginationApi: (id) => {
        return DataService.get(`/student/clone-chapter-sequence-slug/${id}`)
    },

    getChapterHeaderMainApi: (id, data) => {
        return DataService.get(`/student/main-chapter/${id}`, data);
    },
    getHeaderMainOneApi: (id, data) => {
        return DataService.get(`/student/main/header-1/${id}`, data);
    },
    getHeaderMainTwoApi: (id, data) => {
        return DataService.get(`/student/main/header-2/${id}`, data);
    },
    getHeaderMainThreeApi: (id, data) => {
        return DataService.get(`/student/main/header-3/${id}`, data);
    },

}